module.exports = __webpack_public_path__ + "img/MobileAppIcon.c7ad3635.png";